import React, { useEffect, useMemo, useState } from 'react';
import Particles, { initParticlesEngine } from '@tsparticles/react';
import { loadSlim } from '@tsparticles/slim';
import styles from './ParticlesBackground.module.scss';

export default function ParticlesBackground() {
  const [init, setInit] = useState(false);

  useEffect(() => {
    initParticlesEngine(async engine => {
      await loadSlim(engine);
    }).then(() => {
      setInit(true);
    });
  }, []);

  const particlesLoaded = async () => {
    // console.log(container);
  };

  const options = useMemo(
    () => ({
      detectRetina: true,
      fpsLimit: 30,
      background: {
        position: '50% 50%',
        repeat: 'no-repeat',
        size: 'cover',
        opacity: 1,
      },
      interactivity: {
        detectsOn: 'canvas' as any,
        events: {
          resize: true as any,
        },
      },
      particles: {
        color: {
          value: '#fff',
        },
        line_linked: {
          color: '#fff',
          distance: 150,
          enable: true,
          opacity: 0.4,
          width: 1,
        },
        links: {
          value: '#fff',
          width: 2,
          distance: 200,
          opacity: 0.5,
          enable: true,
        },
        number: {
          value: 100,
        },
        opacity: {
          random: {
            enable: false,
          },
          value: 1,
        },
        size: {
          value: 4,
          animation: {
            enable: true,
            minimumValue: 0.5,
            speed: 10,
          },
          random: {
            enable: true,
          },
        },
        collisions: {
          enable: false,
        },
        move: {
          speed: 1,
          enable: true,
          outMode: 'bounce',
        },
      },
    }),
    [],
  );

  if (init) {
    return (
      <div className={styles.container}>
        <Particles
          id="tsparticles"
          particlesLoaded={particlesLoaded}
          options={options}
        />
      </div>
    );
  }

  return null;
}
